"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Layout_1 = require("../../components/Layout");
var react_helmet_1 = require("react-helmet");
var constant_1 = require("../../constant");
exports.default = (function (_a) {
    var _b = _a.staticContext, staticContext = _b === void 0 ? {} : _b;
    staticContext.status = 404;
    return (react_1.default.createElement(Layout_1.Container, null,
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("title", null,
                "404 Non trouv\u00E9 - ",
                constant_1.SITE_TITLE)),
        react_1.default.createElement("div", { style: { fontWeight: "bold", fontSize: 24, marginTop: 20 } }, "Oops, rien sur cette page!")));
});
